import React, { useCallback, useEffect, useState } from "react";
import Information from "../../common/information";
import { useDispatch, useSelector } from "react-redux";
import { editTermsCondition, getTermsCondition } from "../../redux/services/informationSlice";
import { toast } from "react-toastify";

const TermsCondition = () => {
  const dispatch = useDispatch();
  const [editorContent, setEditorContent] = useState("");
  const [selectedType, setSelectedType] = useState("course");

  const termsConditionData = useSelector((state) => state?.information?.termsConditionData);

  const handleEditorChange = (newContent) => {
    setEditorContent(newContent);
  };
  const getTermsConditionData = useCallback(
    async (type) => {
      try {
        await dispatch(getTermsCondition(type));
      } catch (error) {}
    },
    [dispatch]
  );

  useEffect(() => {
    getTermsConditionData(selectedType);
  }, [getTermsConditionData, selectedType]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await dispatch(editTermsCondition({ termsCondition: editorContent, type: selectedType }));
      if (response) {
        toast.success(response?.payload?.message, {
          autoClose: 2000,
          pauseOnHover: false,
        });
        getTermsConditionData();
      }
    } catch (error) {}
  };
  useEffect(() => {
    if (termsConditionData) {
      setEditorContent(termsConditionData?.termsCondition);
    }
  }, [termsConditionData]);
  // const handleExportPDF = () => {
  //   generatePDF(editorContent, "TermsAndCondition.pdf");
  // };
  return (
    <>
      <Information
        title="Terms And Condition"
        handleSubmit={handleSubmit}
        editorContent={editorContent}
        handleEditorChange={handleEditorChange}
        selectedType={selectedType}
        setSelectedType={setSelectedType}
        // handleExportPDF={handleExportPDF}
      />
    </>
  );
};

export default TermsCondition;
